// import { Link, redirect } from "react-router-dom";
// import AuthContext from "../Components/AuthProvider";
// import { useNavigate } from "react-router-dom";
// import React, { useEffect, useState, useContext } from "react";
// import "../Components/Style.css";
// import dgdcImage from "../Images/report.jpeg";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import DatePicker from "react-datepicker";
// import Form from "react-bootstrap/Form";
// import axios from "axios";
// import Select from "react-select";
// import {
//   Button, Card, CardBody, Label,
//   Table, Input, FormGroup
// } from "reactstrap";
// import PDFReport from "./PDFReport";
// import { saveAs } from "file-saver"; // Import file-saver for triggering the download
// import * as XLSX from "xlsx"; // Import XLSX library for creating XLS files
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import ipaddress from "../Components/IpAddress";
// import { toast } from "react-toastify";
// import PartyListTable from "../Parent_Pages/PartyListTable";
// import {
//   faDatabase,
//   faFile,
//   faFileExcel,
//   faFilePdf,
//   faPrint,
//   faSave,
//   faSearch,
//   faSyncAlt,
//   faUndo,
// } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
//   PDFViewer,
//   Image,
//   pdf,
//   Line,
//   BlobProvider,
// } from "@react-pdf/renderer";
// import ReactLoading from 'react-loading';
// import moment from 'moment';
// import Rate_Chart_Service from "../services/Rate_Chart_Service";


// export default function ExportPCTM() {
//   const navigate = useNavigate();
//   const { isAuthenticated } = useContext(AuthContext);
//   const currentDate = new Date();
//   const currentDateString = currentDate.toISOString().split("T")[0];
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const reactPageName = "Export PCTM Data Party";
//   const [cartingAgents, setCartingAgents] = useState([]);
//   const [tpNumbers, setTpNumbers] = useState([]);
//   const [selectedCartingAgent, setSelectedCartingAgent] = useState("");
//   const [serDate, setSerDate] = useState(new Date());
//   const [selectedCartingAgentTpNo, setSelectedCartingAgentTpNo] = useState("");
//   const [exportTpData, setExportTpData] = useState([]);
//   const [exportData, setExportData] = useState([]);
//   const [importAllData, setImportAllData] = useState([]);
//   const [showTable, setShowTable] = useState(false);
//   const [showImportDataTable, setShowImportDataTable] = useState(false);
//   const [pdfReportData, setPDFReportData] = useState([]);
//   const [totalEntries, setTotalEntries] = useState(0);
//   const [summaryDataForTPData, setSummaryDataForTPData] = useState([]); // Define the state variable
//   const [ReordList, setReordList] = useState([]);
//   const [filteredExportData, setfilteredExportData] = useState([]);
//   const [distinctMawbCount, setDistinctMawbCount] = useState(0); // Define the state variable
//   const formattedStartDate = startDate.toISOString().split('T')[0]; // Extract yyyy-MM-dd
//   const formattedEndDate = endDate.toISOString().split('T')[0];
//   const formattedSerDate = serDate.toISOString().split('T')[0];
//   const [Custodian, setCustodian] = useState("Sunil Patil");




//   const {
//     jwtToken,
//     user_Id,
//     username,
//     branchId,
//     companyid,
//     role,
//     companyname,
//     branchname,
//     login,
//     logout,
//   } = useContext(AuthContext);


//   const [loading, setLoading] = useState(false);
//   const styles = {
//     overlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       backgroundColor: 'rgba(255, 255, 255, 0.8)',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 9999,
//     },
//   };

//   const [errors, setErrors] = useState({});

//   const handleConsoleChange = selectedOption => {
//     setSelectedConsole(selectedOption);
//     setSearchCriteria({
//       ...searchCriteria, console: selectedOption ? selectedOption.value : '',
//       consoleName: selectedOption ? selectedOption.label : ''
//     });

//     setExportTpData([]);
//     setExportData([]);
//     setSummaryDataForTPData([]);
//     setAllTpDataSummery([]);
//     setAllTpData([]);
//   };

//   const handleCartingChange = selectedOption => {
//     setSelectedCarting(selectedOption);
//     setSearchCriteria({
//       ...searchCriteria, carting: selectedOption ? selectedOption.value : '',
//       cartingName: selectedOption ? selectedOption.label : ''
//     });
//     if (errors.carting) {
//       const updatedErrors = { ...errors };
//       delete updatedErrors.carting;
//       setErrors(updatedErrors);
//     }

//   };




//   const handleTpNoChange = async selectedOption => {
//     setSearchCriteria({ ...searchCriteria, console: '' });
//     setConsoleArray([]);
//     setSelectedConsole(null)

//     setSelectedTpNo(selectedOption);
//     setSearchCriteria({ ...searchCriteria, tpNo: selectedOption ? selectedOption.value : '' });
//     if (errors.tpNo) {
//       const updatedErrors = { ...errors };
//       delete updatedErrors.tpNo;
//       setErrors(updatedErrors);
//     }
//   };



//   const CustomHeader = () => {
//     return (
//       <View style={styles.header}>
//         <Image src={dgdcImage} style={styles.image} />
//       </View>
//     );
//   };

//   const makeFieldEmpty = () => {
//     setSelectedCarting(null);
//     setSelectedTpNo(null);
//     setSelectedConsole(null);
//     setSerDate(new Date());
//     setExportTpData([]);
//     setExportData([]);
//     setSummaryDataForTPData([]);
//     setAllTpDataSummery([]);
//     setAllTpData([]);
//     setSearchCriteria(initialSearchCriteria);
//     setErrors([]);
//   };


//   const formatPctmNo = (pctmNo) => {
//     // Remove leading zeros using a regular expression
//     return pctmNo.replace(/^0+/, "");
//   };

//   const formatTpNo = (tpNo) => {
//     // Remove leading zeros using a regular expression
//     return tpNo.replace(/^0+/, "");
//   };

//   const [consoleArray, setConsoleArray] = useState([])
//   const [selectedConsole, setSelectedConsole] = useState(null);
//   const [cartingArray, setCartingArray] = useState([])
//   const [selectedCarting, setSelectedCarting] = useState(null);

//   const [tpNoArray, setTpNoArray] = useState([]);
//   const [selectedTpNo, setSelectedTpNo] = useState(null);


//   const formatDateNew = (date) => {
//     if (!date) {
//       date = new Date();
//     }
//     return moment(date).format('YYYY-MM-DD');
//   };


//   const initialSearchCriteria = {
//     companyId: companyid,
//     branchId: branchId,
//     tpNo: '',
//     startDate: formatDateNew(new Date()),
//     endDate: formatDateNew(new Date()),
//     Custodian: 'Sunil Patil',
//     console: '',
//     consoleName: '',
//     carting: '',
//     cartingName: '',
//     userType: 'console'
//   };
//   const [searchCriteria, setSearchCriteria] = useState(initialSearchCriteria);

//   // const handleSearch = async (searchCriteria) => {
//   //   setLoading(true);
//   //   try {
//   //     const response = await Rate_Chart_Service.searchExportTpData({ params: searchCriteria });
//   //     const data = response.data;
//   //     if (data && data.length > 0) {
//   //       settpall(data);
//   //       console.log("tp dataaa \n", data);
//   //     } else {
//   //       setTpdata([]);
//   //     }
//   //     setError([]);
//   //   } catch (error) {
//   //     console.error("Error fetching data:", error);
//   //     setError(error); // Set the error state if there's an error
//   //   }finally
//   //   {
//   //     setLoading(false);
//   //   }
//   // };



//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setSearchCriteria((prevState) => ({
//       ...prevState,
//       [name]: value
//     }));
//   };


//   const findTpNumbers = async () => {
//     setLoading(true);
//     setTpNoArray([]);
//     setSelectedTpNo(null);
//     setAllTpData([]);
//     try {
//       const resultSet = await Rate_Chart_Service.searchTp({ params: searchCriteria });
//       setTpNoArray(resultSet.data);
//     } catch (error) {
//       console.error("Error occurred while fetching data:", error);
//     }
//     finally {
//       setLoading(false);
//     }
//   }



//   const findConsoles = async () => {
//     setLoading(true);
//     setConsoleArray([]);
//     setSelectedConsole(null);
//     try {
//       const partyOptions = await Rate_Chart_Service.searchConsoleForExportTp({ params: searchCriteria })
//       setConsoleArray(partyOptions.data);
//     } catch (error) {
//       console.error("Error occurred while fetching data:", error);
//     }
//     finally {
//       setLoading(false);
//     }
//   }


//   const findCartingAgent = async () => {
//     setLoading(true);
//     setCartingArray([]);
//     setSelectedCarting(null);
//     try {
//       const partyOptions = await Rate_Chart_Service.searchCartingForExportPctm({ params: searchCriteria })
//       setCartingArray(partyOptions.data);
//     } catch (error) {
//       console.error("Error occurred while fetching data:", error);
//     }
//     finally {
//       setLoading(false);
//     }
//   }



//   // Effect to call findTpNumbers when tpDate changes
//   useEffect(() => {
//     findCartingAgent();
//     findTpNumbers();
//   }, [searchCriteria.startDate]); // Dependency array

//   useEffect(() => {
//     findConsoles();
//   }, [searchCriteria.tpNo, searchCriteria.startDate]); // Dependency array



//   // Handle change for date input
//   const handleDateChange = (date) => {
//     setSearchCriteria((prevState) => ({
//       ...prevState,
//       startDate: formatDateNew(date),
//       endDate: formatDateNew(date)
//     }));

//     if (errors.startDate) {
//       const updatedErrors = { ...errors };
//       delete updatedErrors.startDate;
//       setErrors(updatedErrors);
//     }
//   };

  

//   const handleShow = async () => {
//     // You can use this function to display the fetched data in a table or perform other actions


//     // console.log("dd", formattedStartDate);
//     // console.log("dd", formattedEndDate);

//     await axios
//       .get(
//         `https://${ipaddress}export/exportData?companyId=${companyid}&branchId=${branchId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
//       )
//       .then((response) => {
//         const exportData = response.data;

//         setExportData(exportData);
//         console.log("EXport data ", exportData);
//         setShowTable(true);
//         setTotalEntries(exportData.length);
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   };

  
//   useEffect(() => {
//     if (!isAuthenticated) {
//       navigate(
//         "/login?message=You need to be authenticated to access this page."
//       );
//     }
//   }, [isAuthenticated, navigate]);

//   // useEffect(() => {
//   //   // Fetch data from your backend API
//   //   axios
//   //     .get(`https://${ipaddress}export/all/${companyid}/${branchId}`)
//   //     .then((response) => {
//   //       // Assuming your API response is an array of Import objects
//   //       setImportAllDatalist(importAllDatalist);
//   //     })
//   //     .catch((error) => {
//   //       console.error("Error fetching data:", error);
//   //     });
//   // }, []);

//   const formatDate = (inputDate) => {
//     const date = new Date(inputDate);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${day}/${month}/${year}`;
//   };


//   const [allTpData, setAllTpData] = useState([]);
//   const [sumOfNop, setSumOfNop] = useState(0);
//   const [sumOfSB, setSumOfSB] = useState(0);
//   const [sumOfMAWB, setSumOfMAWB] = useState(0);

//   const [allTpDataSummery, setAllTpDataSummery] = useState([]);

//   const handleShowTPData = async (searchCriteria) => {
//     const error = {};
//     // Validate startDate
//     if (!searchCriteria.startDate) {
//       error.startDate = "Start Date is required";
//     }
//     // Validate carting
//     if (!searchCriteria.carting) {
//       error.carting = "Carting is required";
//     }
//     // Validate tpNo
//     if (!searchCriteria.tpNo) {
//       error.tpNo = "TP No is required";
//     }
//     // Check if any errors exist
//     if (Object.keys(error).length > 0) {

//       toast.error("Select required fields", {
//         position: toast.POSITION.TOP_CENTER,
//         autoClose: 1200,
//       });
//       setErrors(error);
//       // Return early if there are errors
//       return;
//     }
//     setLoading(true);
//     try {
//       // const response = await axios.get(
//       //   `https://${ipaddress}export/getExportTpData?companyId=${companyid}&branchId=${branchId}&serDate=${formattedSerDate}&cartingAgent=${selectedCartingAgent}&tpNo=${selectedCartingAgentTpNo}`
//       // );


//       const response = await Rate_Chart_Service.searchExportPctmData({ params: searchCriteria });

//       console.log(' response handleShowTPData \n', response.data);
//       setAllTpData(response.data.tpData);
//       setAllTpDataSummery(response.data.tpSummary);

//       const calculatedSumOfNop = response.data.tpSummary.reduce((acc, curr) => acc + curr[2], 0);
//       const calculatedSumOfSB = response.data.tpSummary.reduce((acc, curr) => acc + curr[3], 0);
//       const calculatedSumOfMAWB = response.data.tpSummary.reduce((acc, curr) => acc + curr[4], 0);

//       setSumOfNop(calculatedSumOfNop);
//       setSumOfSB(calculatedSumOfSB);
//       setSumOfMAWB(calculatedSumOfMAWB);
//     } catch (error) {
//       console.error("Error fetching PCTM data:", error);
//       toast.error("Error fetching PCTM data", {
//         position: toast.POSITION.TOP_CENTER,
//         autoClose: 2000,
//       });
//     } finally {
//       setLoading(false);
//       console.log('Finished handling TP Data request.');
//     }
//   };






  

//   const [pctmRecords, setPctmRecords] = useState({});
//   const [uniquePCTMs, setUniquePCTMs] = useState(new Set());

//   useEffect(() => {
//     const uniquePCTMSet = new Set(); // Create a new Set
//     const pctmGroupedRecords = {};

//     ReordList.forEach((item) => {
//       const { pctmNo } = item;
//       uniquePCTMSet.add(pctmNo);

//       // Add the record to the corresponding MAWB group in the object
//       if (!pctmGroupedRecords[pctmNo]) {
//         pctmGroupedRecords[pctmNo] = [];
//       }
//       pctmGroupedRecords[pctmNo].push(item);
//     });
//     setUniquePCTMs(uniquePCTMs); // Update the state with unique MAWB values
//     setPctmRecords(pctmRecords); // Update the state with grouped records
//   }, [ReordList]);

 
  
//   const formatDateTime2 = (value) => {
//     if (!value) {
//       return "";
//     }
//     const date = new Date(value);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     const hours = String(date.getHours()).padStart(2, "0");
//     const minutes = String(date.getMinutes()).padStart(2, "0");
//     const seconds = String(date.getSeconds()).padStart(2, "0");
//     return `${day}/${month}/${year} `;
//   };
//   const getExcel = async (imp) => {
//     const filename = `Export_PCTM_${formatDateTime2(new Date())}.xlsx`; // Note: Changed file extension to xlsx
//    setLoading(true);
//     try {
//       const response = await axios.post(`https://${ipaddress}export/pctmexcel`, imp, { responseType: 'blob' });
  
//       const blob = new Blob([response.data], { type: response.headers['content-type'] });
  
//       // Create a temporary URL for the blob
//       const url = window.URL.createObjectURL(blob);
  
//       // Create a link element to trigger the download
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
  
//       // Clean up
//       window.URL.revokeObjectURL(url);
//       document.body.removeChild(a);
  
//       toast.success("File downloaded successfully!", {
//         position: toast.POSITION.TOP_CENTER,
//         autoClose: 800,
//       });
//     } catch (error) {
//       console.error("Error in getExcel:", error);
//       toast.error("Something went wrong", {
//         autoClose: 700,
//       });
//     } finally {
//       setLoading(false);
//       console.log("getExcel execution finished.");
//     }
//   };
  



//   const pctmPrint = async (data, data1) => {
//     const combineData = {
//       tpData: data,
//       tpSummery: data1,
//     };

//     const params = {
//       companyId: companyid,
//       branchId: branchId,
//       serDate: searchCriteria.startDate,
//       tpNo: searchCriteria.tpNo,
//       custodian: searchCriteria.Custodian,
//       cartingAgent: searchCriteria.cartingName,
//       consoleName: searchCriteria.consoleName
//     };
//     setLoading(true);
//     try {
//       const response = await axios.post(`https://${ipaddress}export/exportPctmReport`, combineData, { params });
//       const base64PDF = response.data;

//       // Create a new window for displaying the PDF
//       const newWindow = window.open("", "_blank");

//       // Write the HTML content to the new window
//       newWindow.document.write(`
//         <!DOCTYPE html>
//         <html>
//         <head>
//           <title>Export PCTM</title>
//           <style>
//             body {
//               margin: 0;
//               padding: 0;
//               overflow: hidden;
//             }
//             embed {
//               width: 100vw;
//               height: 100vh;
//             }
//           </style>
//         </head>
//         <body>
//           <embed src="data:application/pdf;base64,${base64PDF}" type="application/pdf" width="100%" height="100%">
//         </body>
//         </html>
//       `);
//     } catch (error) {
//       console.error("Error in pctmPrint:", error);
//       toast.error("Something went wrong", {
//         autoClose: 1000,
//       });
//     } finally {
//       // Any cleanup actions, if needed
//       setLoading(false);
//       console.log("pctmPrint execution finished.");
//     }
//   };


//   const pctmPdf = async (data, data1) => {
//     console.log("pctmdata ", data);
//     const combineData = {
//       tpData: data,
//       tpSummery: data1,
//     };

//     const params = {
//       companyId: companyid,
//       branchId: branchId,
//       serDate: searchCriteria.startDate,
//       tpNo: searchCriteria.tpNo,
//       custodian: searchCriteria.Custodian,
//       cartingAgent: searchCriteria.cartingName,
//       consoleName: searchCriteria.consoleName
//     };

//     try {
//       const response = await axios.post(`https://${ipaddress}export/exportPctmReport`, combineData, { params });
//       const pdfBase64 = response.data; // Assuming response.data contains the Base64-encoded PDF

//       // Create a Blob from the Base64 data
//       const pdfBlob = new Blob([Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0))], { type: 'application/pdf' });

//       // Create a URL for the Blob
//       const blobUrl = URL.createObjectURL(pdfBlob);

//       // Create an anchor element for downloading
//       const downloadLink = document.createElement('a');
//       downloadLink.href = blobUrl;
//       downloadLink.download = 'ExportPctm.pdf'; // Set the filename for the downloaded PDF
//       downloadLink.style.display = 'none';
//       document.body.appendChild(downloadLink);

//       // Trigger the download
//       downloadLink.click();

//       // Clean up
//       document.body.removeChild(downloadLink);
//       window.URL.revokeObjectURL(blobUrl);

//       toast.success("Downloading PDF!", {
//         position: toast.POSITION.TOP_CENTER,
//         autoClose: 800,
//       });
//     } catch (error) {
//       console.error("Error in pctmPdf:", error);
//       toast.error("Something went wrong", {
//         autoClose: 1000,
//       });
//     } finally {
//       console.log("pctmPdf execution finished.");
//     }
//   };



//   const ackPrint = async (data, data1) => {
//     console.log("pctmdata ", data)
//     const combineData = {
//       tpData: data,
//       tpSummery: data1
//     }
//     await axios.post(`https://${ipaddress}export/exportAckReport?companyId=${companyid}&branchId=${branchId}&tpNo=${selectedCartingAgentTpNo}&serDate=${formattedSerDate}`, combineData)
//       .then((response) => {
//         const base64PDF = response.data;

//         // Create a new window for displaying the PDF
//         const newWindow = window.open("", "_blank");

//         // Write the HTML content to the new window
//         newWindow.document.write(`
//         <!DOCTYPE html>
//         <html>
//         <head>
//           <title>Export Acknowlegement</title>
//           <style>
//             body {
//               margin: 0;
//               padding: 0;
//               overflow: hidden;
//             }
//             embed {
//               width: 100vw;
//               height: 100vh;
//             }
//           </style>
//         </head>
//         <body>
//           <embed src="data:application/pdf;base64,${base64PDF}" type="application/pdf" width="100%" height="100%">
//         </body>
//         </html>
//       `);
//       })
//       .catch((error) => {
//         if (error) {
//           toast.error("Something went wrong", {
//             autoClose: 1000
//           })
//         }
//       })
//   }

//   const ackPdf = async (data, data1) => {
//     console.log("pctmdata ", data)
//     const combineData = {
//       tpData: data,
//       tpSummery: data1
//     }
//     await axios.post(`https://${ipaddress}export/exportAckReport?companyId=${companyid}&branchId=${branchId}&tpNo=${selectedCartingAgentTpNo}&serDate=${formattedSerDate}`, combineData)
//       .then((response) => {
//         const pdfBase64 = response.data; // Assuming response.data contains the Base64-encoded PDF
//         // Create a Blob from the Base64 data
//         const pdfBlob = new Blob([Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0))], { type: 'application/pdf' });
//         // Create a URL for the Blob
//         const blobUrl = URL.createObjectURL(pdfBlob);
//         // Create an anchor element for downloading
//         const downloadLink = document.createElement('a');
//         downloadLink.href = blobUrl;
//         downloadLink.download = 'ExportAcknowledgement.pdf'; // Set the filename for the downloaded PDF
//         downloadLink.style.display = 'none';
//         document.body.appendChild(downloadLink);
//         // Trigger the download
//         downloadLink.click();
//         // Clean up
//         document.body.removeChild(downloadLink);
//         window.URL.revokeObjectURL(blobUrl);
//         toast.success("Downloading Pdf!", {
//           position: toast.POSITION.TOP_CENTER,
//           autoClose: 800,
//         });
//       })
//       .catch((error) => {
//         if (error) {
//           toast.error("Something went wrong", {
//             autoClose: 1000
//           })
//         }
//       })
//   }
//   // Function to calculate the total for a specific column
//   // const calculateTotal = (data, columnIndex,field) => {
//   //   const total = data.reduce((sum, row) => sum + (parseFloat(row[columnIndex]) || 0), 0);
//   //   // Check if the total has a fractional part
//   //   const roundedTotal = total % 1 !== 0 ? parseFloat(total.toFixed(2)) : total;

//   //   return roundedTotal !== 0 ? roundedTotal : ''; // Return the rounded total or an empty string if zero
//   // };

//   const calculateTotal = (data, columnIndex, field) => {
//     const total = data.reduce((sum, row) => {
//       let value = parseFloat(row[columnIndex]) || 0;

//       // Check the value at the 14th position (index 13)
//       const unit = row[14];

//       if (field === 'GW' && unit === 'KILO GRAMS') {
//         // Convert kilograms to grams
//         value = value * 1000;
//       }

//       // Add the value to the sum
//       return sum + value;
//     }, 0);

//     // Check if the total has a fractional part
//     const roundedTotal = total % 1 !== 0 ? parseFloat(total.toFixed(2)) : total;

//     return roundedTotal !== 0 ? roundedTotal : ''; // Return the rounded total or an empty string if zero
//   };


//   return (

//     <>
//       {loading && (
//         <div style={styles.overlay}>
//           <ReactLoading type="spin" color="#0000FF" height={300} width={80} />
//         </div>
//       )}
//       <div className="Container" >
//         <h5 className="pageHead" style={{ fontFamily: 'Your-Heading-Font', paddingLeft: '2%', paddingRight: '-20px' }} > <FontAwesomeIcon
//           icon={faFile}
//           style={{
//             marginRight: '8px',
//             color: 'black', // Set the color to golden
//           }}
//         />Export PCTM</h5>
//         <Card>
//           <CardBody>
//             <Form>
//               <Row>
//                 <Col md={2}>
//                   <FormGroup>
//                     <Label className="forlabel" for="branchId">Tp Date</Label><span className='error'>*</span>
//                     <DatePicker
//                       selected={searchCriteria.startDate ? new Date(searchCriteria.startDate) : null}
//                       wrapperClassName="custom-react-datepicker-wrapper"
//                       onChange={handleDateChange}
//                       dateFormat="dd/MM/yyyy" // Specify the combined format
//                       className={`form-control border-right-0 inputField ${errors.startDate ? 'error-border' : ''}`}
//                       customInput={<input style={{ width: '100%' }} />}
//                     />
//                   </FormGroup>
//                 </Col>
//                 <Col md={3}>
//                   <FormGroup>
//                     <Label className="forlabel" for="branchId">Select Carting Agent</Label><span className='error'>*</span>
//                     <Select
//                       options={cartingArray}
//                       value={selectedCarting}
//                       onChange={handleCartingChange}
//                       className={errors.carting ? 'error-border' : ''}
//                       isClearable
//                       placeholder="Select Carting Agent"
//                       styles={{
//                         control: (provided, state) => ({
//                           ...provided,
//                           border: state.isFocused ? '1px solid #ccc' : '1px solid #ccc',
//                           boxShadow: 'none',
//                           '&:hover': {
//                             border: '1px solid #ccc'
//                           }
//                         }),
//                         indicatorSeparator: () => ({
//                           display: 'none'
//                         }),
//                         dropdownIndicator: () => ({
//                           display: 'none'
//                         })
//                       }}
//                     />
//                   </FormGroup>
//                 </Col>
//                 <Col md={2}>
//                   <FormGroup>
//                     <Label className="forlabel" for="typeOfProduct">Select Tp No</Label><span className='error'>*</span>
//                     <Select
//                       options={tpNoArray}
//                       value={selectedTpNo}
//                       onChange={handleTpNoChange}
//                       className={errors.tpNo ? 'error-border' : ''}
//                       isClearable
//                       placeholder="Select Tp No"
//                       styles={{
//                         control: (provided, state) => ({
//                           ...provided,
//                           border: state.isFocused ? '1px solid #ccc' : '1px solid #ccc',
//                           // borderColor: errors.consoleName ? '#f52b2b' : '',
//                           boxShadow: 'none',
//                           '&:hover': {
//                             border: '1px solid #ccc'
//                           }
//                         }),
//                         indicatorSeparator: () => ({
//                           display: 'none'
//                         }),
//                         dropdownIndicator: () => ({
//                           display: 'none'
//                         })
//                       }}
//                     />
//                   </FormGroup>
//                 </Col>
//                 <Col md={3}>
//                   <FormGroup>
//                     <Label className="forlabel" for="branchId">Select Console</Label>
//                     <Select
//                       options={consoleArray}
//                       value={selectedConsole}
//                       onChange={handleConsoleChange}
//                       isClearable
//                       placeholder="Select Console"
//                       styles={{
//                         control: (provided, state) => ({
//                           ...provided,
//                           border: state.isFocused ? '1px solid #ccc' : '1px solid #ccc',
//                           boxShadow: 'none',
//                           '&:hover': {
//                             border: '1px solid #ccc'
//                           }
//                         }),
//                         indicatorSeparator: () => ({
//                           display: 'none'
//                         }),
//                         dropdownIndicator: () => ({
//                           display: 'none'
//                         })
//                       }}
//                     />
//                   </FormGroup>
//                 </Col>



//                 <Col md={2} >
//                   <FormGroup>
//                     <Label className="forlabel">
//                       Custodian
//                     </Label>
//                     <Input
//                       type="text"
//                       name="Custodian"
//                       placeholder="Enter Custodian Name"
//                       className=""
//                       value={searchCriteria.Custodian}
//                       onChange={handleChange}
//                     />
//                   </FormGroup>
//                 </Col>




//               </Row>

//               <div className="d-flex justify-content-center align-items-center">
//                 <div style={{ marginTop: 12 }}>
//                   <Button
//                     color="primary"
//                     outline
//                     style={{ marginRight: 9, fontWeight: 'bold' }}
//                     onClick={() => handleShowTPData(searchCriteria)}
//                   >
//                     <FontAwesomeIcon
//                       icon={faSearch}
//                       style={{ marginRight: "5px" }}
//                     />
//                     Search
//                   </Button>

//                   <Button
//                     outline
//                     color="danger"
//                     style={{ fontWeight: 'bold' }}
//                     onClick={(e) => makeFieldEmpty()}
//                   >
//                     <FontAwesomeIcon
//                       icon={faSyncAlt}
//                       style={{ marginRight: "5px" }}
//                     // onClick={handleResetForm}
//                     />
//                     Reset
//                   </Button>
//                 </div>
//               </div>
//             </Form>
//             {allTpData.length > 0 && (
//               <div>
//                 <hr />
//                 {allTpData.length > 0 && (
//                   <div style={{ marginTop: 23 }}>
//                     <Row>
//                       <Col md={2} > <Label className="forlabel" for="search">Download PCTM </Label></Col>
//                       <Col md={4} >

//                         <button
//                           style={{ marginLeft: 9, marginTop: 5, fontWeight: 'bold' }}
//                           className="btn btn-outline-primary btn-margin"
//                           type="button"
//                           onClick={() => pctmPrint(allTpData, allTpDataSummery)}
//                         > <FontAwesomeIcon icon={faPrint} style={{ marginRight: '5px' }} />
//                           Print
//                         </button>
//                         <button
//                           className="btn btn-outline-success btn-margin"
//                           type="button"
//                           onClick={() => pctmPdf(allTpData, allTpDataSummery)}
//                           style={{ marginLeft: "10px", marginTop: 5, fontWeight: 'bold' }}
//                         ><FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px' }} />
//                           PDF
//                         </button>
//                         <button
//                           className="btn btn-outline-primary btn-margin"
//                           type="button"
//                           style={{ marginLeft: "10px", marginRight: 9, marginTop: 5, fontWeight: 'bold' }}
//                           onClick={() => getExcel(allTpData)}
//                         ><FontAwesomeIcon icon={faFileExcel} style={{ marginRight: '5px' }} />
//                           XLS
//                         </button>
//                       </Col>

//                       <Col md={6}>

//                         <Row>

//                           <Col md={6}>

//                             <Label className="forlabel" for="user_Type">

//                               Download Acknowledgement
//                             </Label>

//                           </Col>
//                           <Col md={6}>

//                             <button
//                               style={{ fontWeight: 'bold' }}
//                               className="btn btn-outline-primary btn-margin"
//                               type="button"
//                               onClick={() => ackPrint(allTpData, allTpDataSummery)}
//                             ><FontAwesomeIcon icon={faPrint} style={{ marginRight: '5px' }} />
//                               Print
//                             </button>


//                             <button
//                               style={{ marginLeft: '9px', fontWeight: 'bold' }}
//                               className="btn btn-outline-success btn-margin"
//                               type="button"
//                               onClick={() => ackPdf(allTpData, allTpDataSummery)}
//                             ><FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px' }} />
//                               PDF
//                             </button>


//                           </Col>


//                         </Row>




//                       </Col>

//                     </Row>
//                   </div>
//                 )}

//                 <div className="table-responsive mt-2" >
//                   <Table className="table table-bordered table-hover" style={{ border: '2px solid black' }}>
//                     <thead className="thead-dark bg-dark">
//                       <tr className='text-center' style={{ backgroundColor: '#BADDDA', fontWeight: 'bold', border: '2px solid black', fontSize: '17px', color: 'black', fontFamily: 'Your-Heading-Font', height: '60px' }}>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           Sr.No
//                         </th>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           SER No
//                         </th>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           Parcel Type
//                         </th>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           Destination
//                         </th>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           No Of Packages
//                         </th>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           Shipping Bill No
//                         </th>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           NET Weight
//                         </th>
//                         <th style={{ backgroundColor: '#BADDDA' }}>
//                           Airway Bill No
//                         </th>
//                       </tr>
//                     </thead>

//                     <thead>
//                       <tr className="text-center">
//                         <th style={{ backgroundColor: "#BADDDA" }}>Total</th>
//                         <th style={{ backgroundColor: "#BADDDA" }}> </th>
//                         <th style={{ backgroundColor: "#BADDDA" }}> </th>
//                         <th style={{ backgroundColor: "#BADDDA" }}> </th>
//                         <th style={{ backgroundColor: "#BADDDA" }}>{calculateTotal(allTpData, 3)}</th>
//                         <th style={{ backgroundColor: "#BADDDA" }}>{sumOfSB}</th>
//                         <th style={{ backgroundColor: "#BADDDA" }}>{calculateTotal(allTpData, 5, 'GW')} GMS</th>
//                         <th style={{ backgroundColor: "#BADDDA" }}></th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {allTpData.map((item, index) => (
//                         <tr key={index} className='text-center'>
//                           <td>{index + 1}</td>
//                           <td>{item[0]}</td>
//                           <td>{item[7] === 'Y' ? 'SC' : item[8] === 'Y' ? 'P' : item[9] === 'Y' ? 'HW' : ''}</td>
//                           <td>
//                             {item[1] &&
//                               item[2]
//                               ? `${item[1]} | ${item[2]}`
//                               : ""}
//                           </td>
//                           <td>{item[3]}</td>
//                           <td>{item[4]}</td>
//                           <td>{item[5] + ' (' + (item[14] === 'KILO GRAMS' ? 'KGS' : 'GMS') + ')'}</td>
//                           <td>{item[6]}</td>
//                           {/* Add more table cells as needed */}
//                         </tr>
//                       ))}



//                     </tbody>
//                   </Table>

//                 </div>

//               </div>
//             )}
//             {allTpDataSummery && allTpDataSummery.length > 0 && (
//               <div>
//                 <h5 className="pageHead" style={{ fontFamily: 'Your-Heading-Font', paddingLeft: '4%', paddingRight: '-50px' }} > <FontAwesomeIcon
//                   icon={faDatabase}
//                   style={{
//                     marginRight: '8px',
//                     color: 'black', // Set the color to golden
//                   }}
//                 /> Summary Data</h5>

//                 <div className="table-responsive">
//                   <Table className="table table-bordered table-hover" style={{ border: '2px solid black' }}>
//                     <thead className="thead-dark bg-dark">
//                       <tr className='text-center' style={{ backgroundColor: '#BADDDA', fontWeight: 'bold', border: '2px solid black', fontSize: '17px', color: 'black', fontFamily: 'Your-Heading-Font', height: '60px' }}>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           Airline Name
//                         </th>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           No Of Packages
//                         </th>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           SB Count
//                         </th>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           MAWB Count
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {allTpDataSummery.map((item, index) => (
//                         <tr key={index} className='text-center'>
//                           <td style={{ width: "20%" }}>
//                             {item[1]}
//                           </td>
//                           <td style={{ width: "20%" }}>
//                             {item[2]}
//                           </td>
//                           <td style={{ width: "20%" }}>{item[3]}</td>
//                           <td style={{ width: "20%" }}>
//                             {item[4]}
//                           </td>{" "}
//                           {/* Display distinct MAWB count */}
//                         </tr>
//                       ))}
//                       <tr className='text-center'>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           Total {allTpDataSummery.length} Airlines
//                         </th>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           {sumOfNop}
//                         </th>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           {sumOfSB}
//                         </th>
//                         <th
//                           style={{ backgroundColor: '#BADDDA' }}
//                         >
//                           {sumOfMAWB}
//                         </th>
//                       </tr>

//                     </tbody>
//                   </Table>
//                 </div>
//               </div>
//             )}


//           </CardBody>
//         </Card>
//       </div>
//     </>
//   );
// }










import AuthContext from "../Components/AuthProvider";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useContext } from "react";
import "../Components/Style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DatePicker from "react-datepicker";
import Form from "react-bootstrap/Form";
import axios from "axios";
import Select from "react-select";
import {
  Button, Card, CardBody, Label,
  Table, Input, FormGroup
} from "reactstrap";
import "@react-pdf-viewer/core/lib/styles/index.css";
import ipaddress from "../Components/IpAddress";
import { toast } from "react-toastify";
import {
  faDatabase,
  faFile,
  faFileExcel,
  faFilePdf,
  faPrint,
  faSearch,
  faSyncAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactLoading from 'react-loading';
import moment from 'moment';
import Rate_Chart_Service from "../services/Rate_Chart_Service";


export default function ExportPCTM() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [serDate, setSerDate] = useState(new Date());
  const [selectedCartingAgentTpNo, setSelectedCartingAgentTpNo] = useState("");
  const [exportTpData, setExportTpData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [totalEntries, setTotalEntries] = useState(0);
  const [summaryDataForTPData, setSummaryDataForTPData] = useState([]); // Define the state variable
  const [ReordList, setReordList] = useState([]);
  const formattedStartDate = startDate.toISOString().split('T')[0]; // Extract yyyy-MM-dd
  const formattedEndDate = endDate.toISOString().split('T')[0];
  const formattedSerDate = serDate.toISOString().split('T')[0];




  const {
    branchId,
    companyid    
  } = useContext(AuthContext);


  const [loading, setLoading] = useState(false);
  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    },
  };

  const [errors, setErrors] = useState({});

  const handleConsoleChange = selectedOption => {
    setSelectedConsole(selectedOption);
    setSearchCriteria({
      ...searchCriteria, console: selectedOption ? selectedOption.value : '',
      consoleName: selectedOption ? selectedOption.label : ''
    });

    setExportTpData([]);
    setExportData([]);
    setSummaryDataForTPData([]);
    setAllTpDataSummery([]);
    setAllTpData([]);
  };

  const handleCartingChange = selectedOption => {
    setSelectedCarting(selectedOption);
    setSearchCriteria({
      ...searchCriteria, carting: selectedOption ? selectedOption.value : '',
      cartingName: selectedOption ? selectedOption.label : ''
    });
    if (errors.carting) {
      const updatedErrors = { ...errors };
      delete updatedErrors.carting;
      setErrors(updatedErrors);
    }

  };




  const handleTpNoChange = async selectedOption => {
    setSearchCriteria({ ...searchCriteria, console: '' });
    setConsoleArray([]);
    setSelectedConsole(null)

    setSelectedTpNo(selectedOption);
    setSearchCriteria({ ...searchCriteria, tpNo: selectedOption ? selectedOption.value : '' });
    if (errors.tpNo) {
      const updatedErrors = { ...errors };
      delete updatedErrors.tpNo;
      setErrors(updatedErrors);
    }
  };



  const makeFieldEmpty = () => {
    setSelectedCarting(null);
    setSelectedTpNo(null);
    setSelectedConsole(null);
    setSerDate(new Date());
    setExportTpData([]);
    setExportData([]);
    setSummaryDataForTPData([]);
    setAllTpDataSummery([]);
    setAllTpData([]);
    setSearchCriteria(initialSearchCriteria);
    setErrors([]);
  };



  const [consoleArray, setConsoleArray] = useState([])
  const [selectedConsole, setSelectedConsole] = useState(null);
  const [cartingArray, setCartingArray] = useState([])
  const [selectedCarting, setSelectedCarting] = useState(null);

  const [tpNoArray, setTpNoArray] = useState([]);
  const [selectedTpNo, setSelectedTpNo] = useState(null);


  const formatDateNew = (date) => {
    if (!date) {
      date = new Date();
    }
    return moment(date).format('YYYY-MM-DD');
  };


  const initialSearchCriteria = {
    companyId: companyid,
    branchId: branchId,
    tpNo: '',
    startDate: formatDateNew(new Date()),
    endDate: formatDateNew(new Date()),
    Custodian: 'Sunil Patil',
    console: '',
    consoleName: '',
    carting: '',
    cartingName: '',
    userType: 'console'
  };
  const [searchCriteria, setSearchCriteria] = useState(initialSearchCriteria);

  // const handleSearch = async (searchCriteria) => {
  //   setLoading(true);
  //   try {
  //     const response = await Rate_Chart_Service.searchExportTpData({ params: searchCriteria });
  //     const data = response.data;
  //     if (data && data.length > 0) {
  //       settpall(data);
  //       console.log("tp dataaa \n", data);
  //     } else {
  //       setTpdata([]);
  //     }
  //     setError([]);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setError(error); // Set the error state if there's an error
  //   }finally
  //   {
  //     setLoading(false);
  //   }
  // };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchCriteria((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };


  const findTpNumbers = async () => {
    setLoading(true);
    setTpNoArray([]);
    setSelectedTpNo(null);
    setAllTpData([]);
    try {
      const resultSet = await Rate_Chart_Service.searchTp({ params: searchCriteria });
      setTpNoArray(resultSet.data);
    } catch (error) {
      console.error("Error occurred while fetching data:", error);
    }
    finally {
      setLoading(false);
    }
  }



  const findConsoles = async () => {
    setLoading(true);
    setConsoleArray([]);
    setSelectedConsole(null);
    try {
      const partyOptions = await Rate_Chart_Service.searchConsoleForExportTp({ params: searchCriteria })
      setConsoleArray(partyOptions.data);
    } catch (error) {
      console.error("Error occurred while fetching data:", error);
    }
    finally {
      setLoading(false);
    }
  }


  const findCartingAgent = async () => {
    setLoading(true);
    setCartingArray([]);
    setSelectedCarting(null);
    try {
      const partyOptions = await Rate_Chart_Service.searchCartingForExportPctm({ params: searchCriteria })
      setCartingArray(partyOptions.data);
    } catch (error) {
      console.error("Error occurred while fetching data:", error);
    }
    finally {
      setLoading(false);
    }
  }



  // Effect to call findTpNumbers when tpDate changes
  useEffect(() => {
    findCartingAgent();
    findTpNumbers();
  }, [searchCriteria.startDate]); // Dependency array

  useEffect(() => {
    findConsoles();
  }, [searchCriteria.tpNo, searchCriteria.startDate]); // Dependency array



  // Handle change for date input
  const handleDateChange = (date) => {
    setSearchCriteria((prevState) => ({
      ...prevState,
      startDate: formatDateNew(date),
      endDate: formatDateNew(date)
    }));

    if (errors.startDate) {
      const updatedErrors = { ...errors };
      delete updatedErrors.startDate;
      setErrors(updatedErrors);
    }
  };

  

  const handleShow = async () => {
    // You can use this function to display the fetched data in a table or perform other actions


    // console.log("dd", formattedStartDate);
    // console.log("dd", formattedEndDate);

    await axios
      .get(
        `https://${ipaddress}export/exportData?companyId=${companyid}&branchId=${branchId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
      )
      .then((response) => {
        const exportData = response.data;

        setExportData(exportData);
        console.log("EXport data ", exportData);
        setShowTable(true);
        setTotalEntries(exportData.length);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  
  useEffect(() => {
    if (!isAuthenticated) {
      navigate(
        "/login?message=You need to be authenticated to access this page."
      );
    }
  }, [isAuthenticated, navigate]);

  // useEffect(() => {
  //   // Fetch data from your backend API
  //   axios
  //     .get(`https://${ipaddress}export/all/${companyid}/${branchId}`)
  //     .then((response) => {
  //       // Assuming your API response is an array of Import objects
  //       setImportAllDatalist(importAllDatalist);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // }, []);

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };


  const [allTpData, setAllTpData] = useState([]);
  const [sumOfNop, setSumOfNop] = useState(0);
  const [sumOfSB, setSumOfSB] = useState(0);
  const [sumOfMAWB, setSumOfMAWB] = useState(0);

  const [allTpDataSummery, setAllTpDataSummery] = useState([]);

  const handleShowTPData = async (searchCriteria) => {
    const error = {};
    // Validate startDate
    if (!searchCriteria.startDate) {
      error.startDate = "Start Date is required";
    }
    // Validate carting
    if (!searchCriteria.carting) {
      error.carting = "Carting is required";
    }
    // Validate tpNo
    if (!searchCriteria.tpNo) {
      error.tpNo = "TP No is required";
    }
    // Check if any errors exist
    if (Object.keys(error).length > 0) {

      toast.error("Select required fields", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1200,
      });
      setErrors(error);
      // Return early if there are errors
      return;
    }
    setLoading(true);
    try {
      // const response = await axios.get(
      //   `https://${ipaddress}export/getExportTpData?companyId=${companyid}&branchId=${branchId}&serDate=${formattedSerDate}&cartingAgent=${selectedCartingAgent}&tpNo=${selectedCartingAgentTpNo}`
      // );


      const response = await Rate_Chart_Service.searchExportPctmData({ params: searchCriteria });

      // console.log(' response handleShowTPData \n', response.data);
      setAllTpData(response.data.tpData);
      setAllTpDataSummery(response.data.tpSummary);

      const calculatedSumOfNop = response.data.tpSummary.reduce((acc, curr) => acc + curr[2], 0);
      const calculatedSumOfSB = response.data.tpSummary.reduce((acc, curr) => acc + curr[3], 0);
      const calculatedSumOfMAWB = response.data.tpSummary.reduce((acc, curr) => acc + curr[4], 0);

      setSumOfNop(calculatedSumOfNop);
      setSumOfSB(calculatedSumOfSB);
      setSumOfMAWB(calculatedSumOfMAWB);
    } catch (error) {
      console.error("Error fetching PCTM data:", error);
      toast.error("Error fetching PCTM data", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
      console.log('Finished handling TP Data request.');
    }
  };






  

  const [pctmRecords, setPctmRecords] = useState({});
  const [uniquePCTMs, setUniquePCTMs] = useState(new Set());

  useEffect(() => {
    const uniquePCTMSet = new Set(); // Create a new Set
    const pctmGroupedRecords = {};

    ReordList.forEach((item) => {
      const { pctmNo } = item;
      uniquePCTMSet.add(pctmNo);

      // Add the record to the corresponding MAWB group in the object
      if (!pctmGroupedRecords[pctmNo]) {
        pctmGroupedRecords[pctmNo] = [];
      }
      pctmGroupedRecords[pctmNo].push(item);
    });
    setUniquePCTMs(uniquePCTMs); // Update the state with unique MAWB values
    setPctmRecords(pctmRecords); // Update the state with grouped records
  }, [ReordList]);

 
  
  const formatDateTime2 = (value) => {
    if (!value) {
      return "";
    }
    const date = new Date(value);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}/${month}/${year} `;
  };
  const getExcel = async (imp) => {
    const filename = `Export_PCTM_${formatDateTime2(new Date())}.xlsx`; // Note: Changed file extension to xlsx
   setLoading(true);
    try {
      const response = await axios.post(`https://${ipaddress}export/pctmexcel`, imp, { responseType: 'blob' });
  
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
  
      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(blob);
  
      // Create a link element to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
  
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
  
      toast.success("File downloaded successfully!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    } catch (error) {
      console.error("Error in getExcel:", error);
      toast.error("Something went wrong", {
        autoClose: 700,
      });
    } finally {
      setLoading(false);
      console.log("getExcel execution finished.");
    }
  };
  



  const pctmPrint = async (data, data1) => {
    const combineData = {
      tpData: data,
      tpSummery: data1,
    };

    const params = {
      companyId: companyid,
      branchId: branchId,
      serDate: searchCriteria.startDate,
      tpNo: searchCriteria.tpNo,
      custodian: searchCriteria.Custodian,
      cartingAgent: searchCriteria.cartingName,
      consoleName: searchCriteria.consoleName
    };
    setLoading(true);
    try {
      const response = await axios.post(`https://${ipaddress}export/exportPctmReport`, combineData, { params });
      const base64PDF = response.data;

      // Create a new window for displaying the PDF
      const newWindow = window.open("", "_blank");

      // Write the HTML content to the new window
      newWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Export PCTM</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              overflow: hidden;
            }
            embed {
              width: 100vw;
              height: 100vh;
            }
          </style>
        </head>
        <body>
          <embed src="data:application/pdf;base64,${base64PDF}" type="application/pdf" width="100%" height="100%">
        </body>
        </html>
      `);
    } catch (error) {
      console.error("Error in pctmPrint:", error);
      toast.error("Something went wrong", {
        autoClose: 1000,
      });
    } finally {
      // Any cleanup actions, if needed
      setLoading(false);
      console.log("pctmPrint execution finished.");
    }
  };


  const pctmPdf = async (data, data1) => {
    console.log("pctmdata ", data);
    const combineData = {
      tpData: data,
      tpSummery: data1,
    };

    const params = {
      companyId: companyid,
      branchId: branchId,
      serDate: searchCriteria.startDate,
      tpNo: searchCriteria.tpNo,
      custodian: searchCriteria.Custodian,
      cartingAgent: searchCriteria.cartingName,
      consoleName: searchCriteria.consoleName
    };

    try {
      const response = await axios.post(`https://${ipaddress}export/exportPctmReport`, combineData, { params });
      const pdfBase64 = response.data; // Assuming response.data contains the Base64-encoded PDF

      // Create a Blob from the Base64 data
      const pdfBlob = new Blob([Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0))], { type: 'application/pdf' });

      // Create a URL for the Blob
      const blobUrl = URL.createObjectURL(pdfBlob);

      // Create an anchor element for downloading
      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = 'ExportPctm.pdf'; // Set the filename for the downloaded PDF
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);

      // Trigger the download
      downloadLink.click();

      // Clean up
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(blobUrl);

      toast.success("Downloading PDF!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    } catch (error) {
      console.error("Error in pctmPdf:", error);
      toast.error("Something went wrong", {
        autoClose: 1000,
      });
    } finally {
      console.log("pctmPdf execution finished.");
    }
  };



  const ackPrint = async (data, data1) => {
    console.log("pctmdata ", data)
    const combineData = {
      tpData: data,
      tpSummery: data1
    }
    await axios.post(`https://${ipaddress}export/exportAckReport?companyId=${companyid}&branchId=${branchId}&tpNo=${selectedCartingAgentTpNo}&serDate=${formattedSerDate}`, combineData)
      .then((response) => {
        const base64PDF = response.data;

        // Create a new window for displaying the PDF
        const newWindow = window.open("", "_blank");

        // Write the HTML content to the new window
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Export Acknowlegement</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              overflow: hidden;
            }
            embed {
              width: 100vw;
              height: 100vh;
            }
          </style>
        </head>
        <body>
          <embed src="data:application/pdf;base64,${base64PDF}" type="application/pdf" width="100%" height="100%">
        </body>
        </html>
      `);
      })
      .catch((error) => {
        if (error) {
          toast.error("Something went wrong", {
            autoClose: 1000
          })
        }
      })
  }

  const ackPdf = async (data, data1) => {
    console.log("pctmdata ", data)
    const combineData = {
      tpData: data,
      tpSummery: data1
    }
    await axios.post(`https://${ipaddress}export/exportAckReport?companyId=${companyid}&branchId=${branchId}&tpNo=${selectedCartingAgentTpNo}&serDate=${formattedSerDate}`, combineData)
      .then((response) => {
        const pdfBase64 = response.data; // Assuming response.data contains the Base64-encoded PDF
        // Create a Blob from the Base64 data
        const pdfBlob = new Blob([Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0))], { type: 'application/pdf' });
        // Create a URL for the Blob
        const blobUrl = URL.createObjectURL(pdfBlob);
        // Create an anchor element for downloading
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = 'ExportAcknowledgement.pdf'; // Set the filename for the downloaded PDF
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        // Trigger the download
        downloadLink.click();
        // Clean up
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl);
        toast.success("Downloading Pdf!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      })
      .catch((error) => {
        if (error) {
          toast.error("Something went wrong", {
            autoClose: 1000
          })
        }
      })
  }
  // Function to calculate the total for a specific column
  // const calculateTotal = (data, columnIndex,field) => {
  //   const total = data.reduce((sum, row) => sum + (parseFloat(row[columnIndex]) || 0), 0);
  //   // Check if the total has a fractional part
  //   const roundedTotal = total % 1 !== 0 ? parseFloat(total.toFixed(2)) : total;

  //   return roundedTotal !== 0 ? roundedTotal : ''; // Return the rounded total or an empty string if zero
  // };

  const calculateTotal = (data, columnIndex, field) => {
    const total = data.reduce((sum, row) => {
      let value = parseFloat(row[columnIndex]) || 0;

      // Check the value at the 14th position (index 13)
      // const unit = row[14];

      // if (field === 'GW' && unit === 'KILO GRAMS') {
      //   // Convert kilograms to grams
      //   value = value * 1000;
      // }

      // Add the value to the sum
      return sum + value;
    }, 0);

    // Check if the total has a fractional part
    const roundedTotal = total % 1 !== 0 ? parseFloat(total.toFixed(2)) : total;

    return roundedTotal !== 0 ? roundedTotal : ''; // Return the rounded total or an empty string if zero
  };


  return (

    <>
      {loading && (
        <div style={styles.overlay}>
          <ReactLoading type="spin" color="#0000FF" height={300} width={80} />
        </div>
      )}
      <div className="Container" >
        <h5 className="pageHead" style={{ fontFamily: 'Your-Heading-Font', paddingLeft: '2%', paddingRight: '-20px' }} > <FontAwesomeIcon
          icon={faFile}
          style={{
            marginRight: '8px',
            color: 'black', // Set the color to golden
          }}
        />Export PCTM</h5>
        <Card>
          <CardBody>
            <Form>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <Label className="forlabel" for="branchId">Tp Date</Label><span className='error'>*</span>
                    <DatePicker
                      selected={searchCriteria.startDate ? new Date(searchCriteria.startDate) : null}
                      wrapperClassName="custom-react-datepicker-wrapper"
                      onChange={handleDateChange}
                      dateFormat="dd/MM/yyyy" // Specify the combined format
                      className={`form-control border-right-0 inputField ${errors.startDate ? 'error-border' : ''}`}
                      customInput={<input style={{ width: '100%' }} />}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label className="forlabel" for="branchId">Select Carting Agent</Label><span className='error'>*</span>
                    <Select
                      options={cartingArray}
                      value={selectedCarting}
                      onChange={handleCartingChange}
                      className={errors.carting ? 'error-border' : ''}
                      isClearable
                      placeholder="Select Carting Agent"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: state.isFocused ? '1px solid #ccc' : '1px solid #ccc',
                          boxShadow: 'none',
                          '&:hover': {
                            border: '1px solid #ccc'
                          }
                        }),
                        indicatorSeparator: () => ({
                          display: 'none'
                        }),
                        dropdownIndicator: () => ({
                          display: 'none'
                        })
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label className="forlabel" for="typeOfProduct">Select Tp No</Label><span className='error'>*</span>
                    <Select
                      options={tpNoArray}
                      value={selectedTpNo}
                      onChange={handleTpNoChange}
                      className={errors.tpNo ? 'error-border' : ''}
                      isClearable
                      placeholder="Select Tp No"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: state.isFocused ? '1px solid #ccc' : '1px solid #ccc',
                          // borderColor: errors.consoleName ? '#f52b2b' : '',
                          boxShadow: 'none',
                          '&:hover': {
                            border: '1px solid #ccc'
                          }
                        }),
                        indicatorSeparator: () => ({
                          display: 'none'
                        }),
                        dropdownIndicator: () => ({
                          display: 'none'
                        })
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label className="forlabel" for="branchId">Select Console</Label>
                    <Select
                      options={consoleArray}
                      value={selectedConsole}
                      onChange={handleConsoleChange}
                      isClearable
                      placeholder="Select Console"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: state.isFocused ? '1px solid #ccc' : '1px solid #ccc',
                          boxShadow: 'none',
                          '&:hover': {
                            border: '1px solid #ccc'
                          }
                        }),
                        indicatorSeparator: () => ({
                          display: 'none'
                        }),
                        dropdownIndicator: () => ({
                          display: 'none'
                        })
                      }}
                    />
                  </FormGroup>
                </Col>



                <Col md={2} >
                  <FormGroup>
                    <Label className="forlabel">
                      Custodian
                    </Label>
                    <Input
                      type="text"
                      name="Custodian"
                      placeholder="Enter Custodian Name"
                      className=""
                      value={searchCriteria.Custodian}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>




              </Row>

              <div className="d-flex justify-content-center align-items-center">
                <div style={{ marginTop: 12 }}>
                  <Button
                    color="primary"
                    outline
                    style={{ marginRight: 9, fontWeight: 'bold' }}
                    onClick={() => handleShowTPData(searchCriteria)}
                  >
                    <FontAwesomeIcon
                      icon={faSearch}
                      style={{ marginRight: "5px" }}
                    />
                    Search
                  </Button>

                  <Button
                    outline
                    color="danger"
                    style={{ fontWeight: 'bold' }}
                    onClick={(e) => makeFieldEmpty()}
                  >
                    <FontAwesomeIcon
                      icon={faSyncAlt}
                      style={{ marginRight: "5px" }}
                    // onClick={handleResetForm}
                    />
                    Reset
                  </Button>
                </div>
              </div>
            </Form>
            {allTpData.length > 0 && (
              <div>
                <hr />
                {allTpData.length > 0 && (
                  <div style={{ marginTop: 23 }}>
                    <Row>
                      <Col md={2} > <Label className="forlabel" for="search">Download PCTM </Label></Col>
                      <Col md={4} >

                        <button
                          style={{ marginLeft: 9, marginTop: 5, fontWeight: 'bold' }}
                          className="btn btn-outline-primary btn-margin"
                          type="button"
                          onClick={() => pctmPrint(allTpData, allTpDataSummery)}
                        > <FontAwesomeIcon icon={faPrint} style={{ marginRight: '5px' }} />
                          Print
                        </button>
                        <button
                          className="btn btn-outline-success btn-margin"
                          type="button"
                          onClick={() => pctmPdf(allTpData, allTpDataSummery)}
                          style={{ marginLeft: "10px", marginTop: 5, fontWeight: 'bold' }}
                        ><FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px' }} />
                          PDF
                        </button>
                        <button
                          className="btn btn-outline-primary btn-margin"
                          type="button"
                          style={{ marginLeft: "10px", marginRight: 9, marginTop: 5, fontWeight: 'bold' }}
                          onClick={() => getExcel(allTpData)}
                        ><FontAwesomeIcon icon={faFileExcel} style={{ marginRight: '5px' }} />
                          XLS
                        </button>
                      </Col>

                      <Col md={6}>

                        <Row>

                          <Col md={6}>

                            <Label className="forlabel" for="user_Type">

                              Download Acknowledgement
                            </Label>

                          </Col>
                          <Col md={6}>

                            <button
                              style={{ fontWeight: 'bold' }}
                              className="btn btn-outline-primary btn-margin"
                              type="button"
                              onClick={() => ackPrint(allTpData, allTpDataSummery)}
                            ><FontAwesomeIcon icon={faPrint} style={{ marginRight: '5px' }} />
                              Print
                            </button>


                            <button
                              style={{ marginLeft: '9px', fontWeight: 'bold' }}
                              className="btn btn-outline-success btn-margin"
                              type="button"
                              onClick={() => ackPdf(allTpData, allTpDataSummery)}
                            ><FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px' }} />
                              PDF
                            </button>


                          </Col>


                        </Row>




                      </Col>

                    </Row>
                  </div>
                )}

                <div className="table-responsive mt-2" >
                  <Table className="table table-bordered table-hover" style={{ border: '2px solid black' }}>
                    <thead className="thead-dark bg-dark">
                      <tr className='text-center' style={{ backgroundColor: '#BADDDA', fontWeight: 'bold', border: '2px solid black', fontSize: '17px', color: 'black', fontFamily: 'Your-Heading-Font', height: '60px' }}>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          Sr.No
                        </th>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          SER No
                        </th>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          Parcel Type
                        </th>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          Destination
                        </th>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          No Of Packages
                        </th>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          Shipping Bill No
                        </th>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          NET Weight
                        </th>
                        <th style={{ backgroundColor: '#BADDDA' }}>
                          Airway Bill No
                        </th>
                      </tr>
                    </thead>

                    <thead>
                      <tr className="text-center">
                        <th style={{ backgroundColor: "#BADDDA" }}>Total</th>
                        <th style={{ backgroundColor: "#BADDDA" }}> </th>
                        <th style={{ backgroundColor: "#BADDDA" }}> </th>
                        <th style={{ backgroundColor: "#BADDDA" }}> </th>
                        <th style={{ backgroundColor: "#BADDDA" }}>{calculateTotal(allTpData, 3)}</th>
                        <th style={{ backgroundColor: "#BADDDA" }}>{sumOfSB}</th>
                        <th style={{ backgroundColor: "#BADDDA" }}>{calculateTotal(allTpData, 5, 'GW')} KG</th>
                        <th style={{ backgroundColor: "#BADDDA" }}></th>
                      </tr>
                    </thead>

                    <tbody>
                      {allTpData.map((item, index) => (
                        <tr key={index} className='text-center'>
                          <td>{index + 1}</td>
                          <td>{item[0]}</td>
                          <td>{item[7] === 'Y' ? 'SC' : item[8] === 'Y' ? 'P' : item[9] === 'Y' ? 'HW' : ''}</td>
                          <td>
                            {item[1] &&
                              item[2]
                              ? `${item[1]} | ${item[2]}`
                              : ""}
                          </td>
                          <td>{item[3]}</td>
                          <td>{item[4]}</td>
                          <td>{item[5] + ' (' + (item[14] === 'KILO GRAMS' ? 'KGS' : 'KGS' ? 'KGS' : 'GMS') + ')'}</td>
                          <td>{item[6]}</td>
                          {/* Add more table cells as needed */}
                        </tr>
                      ))}



                    </tbody>
                  </Table>

                </div>

              </div>
            )}
            {allTpDataSummery && allTpDataSummery.length > 0 && (
              <div>
                <h5 className="pageHead" style={{ fontFamily: 'Your-Heading-Font', paddingLeft: '4%', paddingRight: '-50px' }} > <FontAwesomeIcon
                  icon={faDatabase}
                  style={{
                    marginRight: '8px',
                    color: 'black', // Set the color to golden
                  }}
                /> Summary Data</h5>

                <div className="table-responsive">
                  <Table className="table table-bordered table-hover" style={{ border: '2px solid black' }}>
                    <thead className="thead-dark bg-dark">
                      <tr className='text-center' style={{ backgroundColor: '#BADDDA', fontWeight: 'bold', border: '2px solid black', fontSize: '17px', color: 'black', fontFamily: 'Your-Heading-Font', height: '60px' }}>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          Airline Name
                        </th>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          No Of Packages
                        </th>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          SB Count
                        </th>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          MAWB Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {allTpDataSummery.map((item, index) => (
                        <tr key={index} className='text-center'>
                          <td style={{ width: "20%" }}>
                            {item[1]}
                          </td>
                          <td style={{ width: "20%" }}>
                            {item[2]}
                          </td>
                          <td style={{ width: "20%" }}>{item[3]}</td>
                          <td style={{ width: "20%" }}>
                            {item[4]}
                          </td>{" "}
                          {/* Display distinct MAWB count */}
                        </tr>
                      ))}
                      <tr className='text-center'>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          Total {allTpDataSummery.length} Airlines
                        </th>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          {sumOfNop}
                        </th>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          {sumOfSB}
                        </th>
                        <th
                          style={{ backgroundColor: '#BADDDA' }}
                        >
                          {sumOfMAWB}
                        </th>
                      </tr>

                    </tbody>
                  </Table>
                </div>
              </div>
            )}


          </CardBody>
        </Card>
      </div>
    </>
  );
}







